/* eslint semi:0 */
import { isMobile, isTablet, } from 'utils/ua'
import { wrapButtonInLabel, } from 'views/ButtonView'
import SocialButtonsBaseVm from './SocialButtonsBaseVm'
import socialButtonsConf from 'config/socialButtonsConfig'
import { isPostMainMediaImage, } from 'application/pageDataObject'


export default class CoverSocialButtonsVm extends SocialButtonsBaseVm {

  get shouldRenderButtons(){
    return isPostMainMediaImage
  }

  getVisibleButtons(){
    if (!this.shouldRenderButtons) {
      return []
    }
    const { facebook, twitter, comments, embed, } = socialButtonsConf
    const baseButtons = [ facebook, twitter, ]
    let result
    switch (true) {
      case isMobile:
        result = [ ...baseButtons, ] //these buttons will be hidden with CSS
        // but they are currently needed in order to receive the flux action
        // of ACTIONS.REACHED_COVER_SOCIAL_COMPONENT
        break
      case isTablet:
        result = baseButtons
        break
      default:
        result = [ ...baseButtons, embed, comments, ]
        break
    }
    return result
      .filter(this.filterByExcludedFeatureId)
      .map(wrapButtonInLabel)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/socialButtons/CoverSocialButtonsVm.js